import React from 'react';
import Select from 'react-select';


// CODE SELECT FOR DOWNTIME CODE OPTION
// CODE SELECT FOR DOWNTIME CODE OPTION
const options = [
  { value: '1: Sanitise/Setup', label: '1: Sanitise/Setup' },
  { value: '2: Product Changeover', label: '2: Product Changeover' },
  { value: '3: Packaging Changeover', label: '3: Packaging Changeover' },
  { value: '10: Size Changeover', label: '10: Size Changeover' },
  { value: '4: CIP/Cleaning (incl. manual cleaning)', label: '4: CIP/Cleaning (incl. manual cleaning)' },
  { value: '8: Mid Production Sanitise', label: '8: Mid Production Sanitise' },
  { value: '5: Preventative Maintenance', label: '5: Preventative Maintenance' },
  { value: '6: Staff Related - Planned', label: '6: Staff Related - Planned' },
  { value: '99: Partial Interrupt', label: '99: Partial Interrupt' },
  { value: '11: Waiting - Product', label: '11: Waiting - Product' },
  { value: '115: Waiting - Raw milk unavailable', label: '115: Waiting - Raw milk unavailable' },
  { value: '12: Waiting - Materials', label: '12: Waiting - Materials' },
  { value: '15: Waiting - Cold room', label: '15: Waiting - Cold room' },
  { value: '16: Waiting - Crates', label: '16: Waiting - Crates' },
  { value: '17: Waiting - Test', label: '17: Waiting - Test' },
  { value: '18: Waiting - Staff Related - Unplanned', label: '18: Waiting - Staff Related - Unplanned' },
  { value: '19: Waiting - Packing', label: '19: Waiting - Packing' },
  { value: '20: Waiting - Material Restocking', label: '20: Waiting - Material Restocking' },
  { value: '24: Waiting - CIP', label: '24: Waiting - CIP' },
  { value: '29: Fault - Unscrambler', label: '29: Fault - Unscrambler' },
  { value: '30: Fault - Infeed', label: '30: Fault - Infeed' },
  { value: '33: Fault - Labelling', label: '33: Fault - Labelling' },
  { value: '34: Fault - Coding', label: '34: Fault - Coding' },
  { value: '35: Fault - Filling', label: '35: Fault - Filling' },
  { value: '36: Fault - Lidding', label: '36: Fault - Lidding' },
  { value: '37: Fault - Sealing', label: '37: Fault - Sealing' },
  { value: '38: Fault - Capping', label: '38: Fault - Capping' },
  { value: '40: Fault - Outfeed', label: '40: Fault - Outfeed' },
  { value: '48: Fault - Pack Sterilisation', label: '48: Fault - Pack Sterilisation' },
  { value: '49: Fault - Packaging', label: '49: Fault - Packaging' },
  { value: '50: Fault - Multipack', label: '50: Fault - Multipack' },
  { value: '51: Fault - Crate Packing', label: '51: Fault - Crate Packing' },
  { value: '52: Fault - Carton/Box Packing', label: '52: Fault - Carton/Box Packing' },
  { value: '53: Fault - Crate Stacking', label: '53: Fault - Crate Stacking' },
  { value: '54: Fault - Palletising', label: '54: Fault - Palletising' },
  { value: '55: Fault - Downstream Conveying/Transfer', label: '55: Fault - Downstream Conveying/Transfer' },
  { value: '56: Fault - TUN Labelling', label: '56: Fault - TUN Labelling' },
  { value: '95: Fault - Crate Broken', label: '95: Fault - Crate Broken' },
  { value: '70: Other - Site Related Downtime', label: '70: Other - Site Related Downtime' },
  { value: '80: Fault - CIP', label: '80: Fault - CIP' }
];



const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#93C2E4' : 'transparent',
    color: '#3f3f3f',
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: 'var(--input)',
    borderColor: '#ccc',
    boxShadow: 'none',
    width: '360px',
    height: '40px',
    // textAlign: 'center',
   
  }),
  singleValue: (provided) => ({
    ...provided,
    lineHeight: 'normal',
    // textAlign: 'center',
  }),
};

const CodeSelect = ({ value, onChange }) => (
  <Select
    styles={customStyles}
    options={options}
    value={options.find(opt => opt.value === value)}
    onChange={(selected) => onChange(selected.value)}
  />
);

export default CodeSelect;
